'use strict';

var pseudoStyle = require('./pseudo-style');
module.exports = pseudoStyle('hover')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/hover.js
// module id = 4367
// module chunks = 168707334958949